/*
  HALO Órbita: fotos que entram girando em sentido horário ao redor do texto central.

  - O progresso acompanha a rolagem: começa quando o topo da seção entra pela base da tela
    e termina quando o meio da seção chega ao meio da tela ("Rolagem até completar" = 100%).
  - Vale nos dois sentidos: descendo, as fotos giram em sentido horário até o lugar;
    subindo, fazem o caminho de volta (anti-horário, diminuindo) conforme a seção sai pela
    base da tela.
  - Cada foto anda num arco quase circular (elíptico, na proporção da área) do ângulo
    final menos o giro até o ângulo final, crescendo do tamanho inicial até 100%.
  - Só transform e opacity. Sem animação para quem pede menos movimento e no editor de temas.
*/
(function () {
  'use strict';

  if (!window.customElements || customElements.get('halo-orbita')) return;

  var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function ease(t) {
    return -(Math.cos(Math.PI * t) - 1) / 2;
  }

  class HaloOrbita extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.ac = new AbortController();
      this.setupBuy();

      var designMode = !!(window.Shopify && window.Shopify.designMode);
      if (this.dataset.animate !== 'true' || reduceQuery.matches || designMode) return;

      var self = this;
      var passive = { signal: this.ac.signal, passive: true };
      this.sweep = (parseFloat(this.dataset.sweep) || 150) * Math.PI / 180;
      this.startScale = (parseFloat(this.dataset.startScale) || 30) / 100;
      this.distance = (parseFloat(this.dataset.distance) || 100) / 100;
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-ho-item]')).map(function (item) {
        return { item: item, card: item.querySelector('[data-ho-card]') };
      });
      if (!this.items.length) return;
      var count = this.items.length;
      this.stagger = count > 1 ? Math.min(0.08, 0.4 / (count - 1)) : 0;

      this.measure();
      this.shown = this.target();
      this.render(this.shown);

      this.onScroll = function () {
        if (!self.raf) self.raf = requestAnimationFrame(self.tick.bind(self));
      };
      window.addEventListener('scroll', this.onScroll, passive);
      this.ro = new ResizeObserver(function () {
        self.measure();
        self.render(self.shown);
      });
      this.ro.observe(this);
    }

    disconnectedCallback() {
      if (!this.started) return;
      this.started = false;
      this.ac.abort();
      if (this.ro) this.ro.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    // Posição final de cada foto, normalizada pela metade da largura e da altura da área.
    measure() {
      var stage = this.getBoundingClientRect();
      this.halfW = stage.width / 2 || 1;
      this.halfH = stage.height / 2 || 1;
      var cx = stage.left + this.halfW;
      var cy = stage.top + this.halfH;
      var self = this;
      this.items.forEach(function (entry) {
        var r = entry.item.getBoundingClientRect();
        var u = (r.left + r.width / 2 - cx) / self.halfW;
        var v = (r.top + r.height / 2 - cy) / self.halfH;
        entry.fx = u * self.halfW;
        entry.fy = v * self.halfH;
        entry.rho = Math.hypot(u, v);
        entry.theta = Math.atan2(v, u);
        entry.hidden = r.width === 0;
      });
    }

    // Progresso pela rolagem: do topo da seção entrando pela base da tela (0) até o meio da
    // seção no meio da tela (1). Subindo, o mesmo caminho volta.
    target() {
      var rect = this.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var travel = (vh / 2 + rect.height / 2) * this.distance;
      return clamp((vh - rect.top) / travel, 0, 1);
    }

    // Suaviza o acompanhamento da rolagem nos dois sentidos.
    tick() {
      this.raf = 0;
      var goal = this.target();
      this.shown += (goal - this.shown) * 0.2;
      if (Math.abs(goal - this.shown) < 0.002) this.shown = goal;
      this.render(this.shown);
      if (this.shown !== goal) this.raf = requestAnimationFrame(this.tick.bind(this));
    }

    render(p) {
      var count = this.items.length;
      var span = 1 - this.stagger * (count - 1);
      var done = p >= 1;
      for (var i = 0; i < count; i++) {
        var entry = this.items[i];
        var card = entry.card;
        if (!card || entry.hidden) continue;
        if (done) {
          card.style.transform = '';
          card.style.opacity = '';
          card.style.willChange = '';
          continue;
        }
        var local = clamp((p - i * this.stagger) / span, 0, 1);
        var e = ease(local);
        var theta = entry.theta - this.sweep * (1 - e);
        var rho = entry.rho * (0.85 + 0.15 * e);
        var x = rho * Math.cos(theta) * this.halfW;
        var y = rho * Math.sin(theta) * this.halfH;
        var scale = this.startScale + (1 - this.startScale) * e;
        card.style.willChange = 'transform, opacity';
        card.style.transform =
          'translate3d(' + (x - entry.fx).toFixed(1) + 'px,' + (y - entry.fy).toFixed(1) + 'px,0) scale(' + scale.toFixed(3) + ')';
        card.style.opacity = clamp(local * 3, 0, 1).toFixed(3);
      }
    }

    // Botão sem link: rola até a seção de compra da página.
    setupBuy() {
      var link = this.querySelector('[data-ho-buy]');
      if (!link) return;
      link.addEventListener('click', function (e) {
        var target =
          document.querySelector('[id$="__main_product"]') ||
          document.querySelector('xo-product[xo-product-information]');
        if (!target) return;
        e.preventDefault();
        var header = document.querySelector('[data-halo-header-bar]') || document.querySelector('.xo-header__inner');
        var offset = header ? Math.max(0, header.getBoundingClientRect().bottom) + 16 : 16;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: reduceQuery.matches ? 'auto' : 'smooth' });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }, { signal: this.ac.signal });
    }
  }

  customElements.define('halo-orbita', HaloOrbita);
})();
